<template>
  <div class="mainDataStatisticsContainer">
    <el-form
      :inline="true"
      :model="chartForm"
      class="demo-form-inline dataStatisticsForms"
      style="margin-top: 5px"
    >
      <el-form-item label="查询范围:" class="selectFormItem" style="margin-right: 33px">
        <el-select
          v-model="chartForm.mark"
          placeholder="查询范围"
          popper-class="adminHomeSelect"
          @change="changeStatisticsTime"
        >
          <el-option label="月" value="month"></el-option>
          <el-option label="季度" value="quarter"></el-option>
          <el-option label="年" value="year"></el-option>
        </el-select> </el-form-item
      ><el-form-item label="时间范围:">
        <MyDatePicker
          :type="chartForm.mark"
          @resetDateRange="resetDateRange"
          ref="myDatePicker"
        ></MyDatePicker> </el-form-item
      ><el-form-item
        ><el-button
          icon="el-icon-operte-view"
          class="queryBtn"
          style="margin-right: 10px"
          @click="doRenderChart"
          >查询</el-button
        ></el-form-item
      >
    </el-form>
    <div class="chartMainContainer">
      <div class="chartContainer" id="taskChart"></div>
      <div class="chartContainer" id="planChart"></div>
      <div class="chartContainer" id="statisticsChart"></div>
    </div>
    <el-form
      :inline="true"
      :model="tableForm"
      class="demo-form-inline dataStatisticsForms"
    >
      <el-form-item
        label="计划名称:"
        class="selectFormItem selectFormItem2"
        style="margin-right: 25px"
      >
        <el-input v-model="tableForm.flightName"></el-input>
      </el-form-item>
      <el-form-item
        label="创建人员:"
        class="selectFormItem selectFormItem2"
        style="margin-right: 24px"
      >
        <el-input v-model="tableForm.userName"></el-input>
      </el-form-item>
      <el-form-item label="无人机:" class="selectFormItem selectFormItem2">
        <el-input v-model="tableForm.uasSerialId"></el-input>
      </el-form-item>
      <el-form-item
        ><el-button
          icon="el-icon-operte-view"
          class="queryBtn"
          style="margin-right: 10px"
          @click="query"
          >查询</el-button
        ></el-form-item
      >
    </el-form>
    <div class="mainTableContainer">
      <el-table
        class="table"
        :data="tableData"
        style="width: 100%"
        ref="commonTable"
      >
        <el-table-column
          prop="local_id"
          label="计划编号"
          min-width="150"
          align="center"
          :show-overflow-tooltip="true"
        ></el-table-column>
        <el-table-column
          prop="flight_name"
          label="计划名称"
          min-width="150"
          align="center"
          :show-overflow-tooltip="true"
        ></el-table-column>
        <el-table-column
          prop="user_name"
          label="创建人员"
          min-width="150"
          align="center"
          :show-overflow-tooltip="true"
        ></el-table-column>
        <el-table-column
          prop="uas_serial_id"
          label="无人机"
          min-width="150"
          align="center"
          :show-overflow-tooltip="true"
        ></el-table-column>
        <el-table-column
          prop="flight_status"
          label="计划状态"
          min-width="150"
          align="center"
          :show-overflow-tooltip="true"
          ><template slot-scope="scope">
            <span v-if="scope.row.flight_status === 10">待取货</span>
            <span v-else-if="scope.row.flight_status === 15">已提交</span>
            <span v-else-if="scope.row.flight_status === 20">待审核</span>
            <span v-else-if="scope.row.flight_status === 30">驳回</span
            ><span v-else-if="scope.row.flight_status === 40">审核通过</span
            ><span v-else-if="scope.row.flight_status === 50">待飞行</span
            ><span v-else-if="scope.row.flight_status === 60">正在飞行</span
            ><span v-else-if="scope.row.flight_status === 70">飞行结束</span>
            <span v-else-if="scope.row.flight_status === 90">任务完成</span>
          </template>
        </el-table-column>
      </el-table>
      <!-- 分页 -->
      <div
        style="text-align: right; margin-top: 15px; margin-right: 0px; height: 40px;"
        id="pages"
      >
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="current"
          :page-sizes="[6, 16, 24, 32]"
          :page-size="size"
          layout="total, sizes, prev, pager, next"
          :total="totalCount"
          popper-class="adminHomeSelect"
        ></el-pagination>
      </div>
    </div>
  </div>
</template>

<script>
import { postJsonRequest, getRequest } from "../../../axios/api";
import MyDatePicker from "./myDatePicker";
import * as echarts from "echarts";

//文本样式
const TEXT_STYLE = {
  color: "#FFFFFF",
  fontSize: 14,
  fontFamily: "Alibaba PuHuiTi",
  fontWeight: 400,
};

export default {
  name: "dataStatistics",
  props: [],
  data() {
    return {
      chartForm: { mark: "month", dateRange: "" },
      tableForm: { flightName: "", uasSerialId: "", userName: "" },
      tableData: [],
      current: 1, //当前页数
      size: 6, //显示几条
      totalCount: 0, //总条数
    };
  },
  mounted() {
    this.setGutterWidth();
    this.initDateRange();
    this.doRenderChart();
    this.query();
  },
  methods: {
    doRenderChart() {
      this.resetRequestTime();
      this.renderTaskChart();
      this.renderPlanChart();
      this.renderStatisticsChart();
    },
    renderTaskChart() {
      const chartForm = { ...this.$data.chartForm };
      getRequest(
        "/uav-task-server/mission/getMissionStatisticsForGraphics.do?" +
          this.getChartParam()
      )
        .then((res) => {
          res = res.data;
          if (null != res && 0 == res.code) {
            if (null != res.data) {
              const datas = res.data;
              const chartOptions = {
                id: "taskChart",
                title: "任务查询",
                legendTitle: ["历史任务", "已完成任务", "未完成任务"],
                chartColors: ["#FFA63E", "#0083FD", "#F74347"],
                chartXAxis: [],
                chartType: "bar",
                datas: [[], [], []],
              };
              this.renderChart(
                this.missionAndPlanDataParse(chartOptions, datas, chartForm)
              );
            }
          } else if (res.code != 401) {
            // let msg = "请求数据失败";
            // if (!this.isEmptyStr(res.msg)) {
            //   msg = res.msg;
            // }
            // let tips = "<i class='el-icon-warn-tip'></i>" + msg;
            // this.$confirm(tips, "提示", {
            //   confirmButtonText: "好的",
            //   customClass: "customClass-style",
            //   iconClass: "",
            //   dangerouslyUseHTMLString: true,
            //   confirmButtonClass: "confirm-style",
            //   showCancelButton: false,
            // });
          }
        })
        .catch((error) => {});
    },
    renderPlanChart() {
      const chartForm = { ...this.$data.chartForm };
      getRequest(
        "/uav-task-server/flight/getFlightStatisticsForGraphics.do?" +
          this.getChartParam()
      )
        .then((res) => {
          res = res.data;
          if (null != res && 0 == res.code) {
            if (null != res.data) {
              const datas = res.data;
              const chartOptions = {
                id: "planChart",
                title: "计划查询",
                legendTitle: ["计划总量", "已完成", "未完成"],
                chartColors: ["#FFA63E", "#2AC692", "#F74347"],
                chartXAxis: [],
                chartType: "bar",
                datas: [[], [], []],
              };
              this.renderChart(
                this.missionAndPlanDataParse(chartOptions, datas, chartForm)
              );
            }
          } else if (res.code != 401) {
            // let msg = "请求数据失败";
            // if (!this.isEmptyStr(res.msg)) {
            //   msg = res.msg;
            // }
            // let tips = "<i class='el-icon-warn-tip'></i>" + msg;
            // this.$confirm(tips, "提示", {
            //   confirmButtonText: "好的",
            //   customClass: "customClass-style",
            //   iconClass: "",
            //   dangerouslyUseHTMLString: true,
            //   confirmButtonClass: "confirm-style",
            //   showCancelButton: false,
            // });
          }
        })
        .catch((error) => {});
    },
    renderStatisticsChart() {
      const chartForm = { ...this.$data.chartForm };
      getRequest(
        "/uav-task-server/flight/getFlightDetailInfoStatisticsForGraphics.do?" +
          this.getChartParam()
      )
        .then((res) => {
          res = res.data;
          if (null != res && 0 == res.code) {
            if (null != res.data) {
              const datas = res.data;
              const legendTitle = [
                "累计完成任务",
                "累计完成计划",
                "累计飞行时间",
                "累计运输重量",
                "累计运输里程",
              ];
              const chartOptions = {
                id: "statisticsChart",
                title: "数据统计",
                legendTitle,
                legend: {
                  data: legendTitle,
                  bottom: 4,
                  textStyle: { ...TEXT_STYLE, padding: [-3, 24, 0, 0] },
                  itemWidth: 8,
                  itemHeight: 8,
                  icon: "rect",
                },
                grid: { top: 35, right: 76, bottom: 72, left: 63 },
                chartColors: ["#FFA63E", "#2AC692", "#0083FD", "#00FFFF", "#F74347"],
                chartXAxis: [],
                chartType: "line",
                datas: [[], [], [], [], []],
                yAxisIndexs: [0, 0, 1, 1, 1],
                tooltipFormatter: function (params) {
                  var relVal = params[0].name;
                  for (var i = 0, l = params.length; i < l; i++) {
                    relVal +=
                      "<br/>" +
                      params[i].marker +
                      params[i].seriesName +
                      " : " +
                      params[i].value;
                    if (i === 2) {
                      relVal += "H";
                    } else if (i === 3) {
                      relVal += "KG";
                    } else if (i === 4) {
                      relVal += "KM";
                    }
                  }
                  return relVal;
                },
                yAxis: [
                  {
                    type: "value",
                    axisLabel: TEXT_STYLE,
                    axisLine: { lineStyle: { color: "#FFFFFF" } },
                    axisTick: { lineStyle: { color: "#FFFFFF" } },
                    splitLine: { lineStyle: { color: "#FFFFFF10" } },
                    position: "left",
                    splitNumber: 5,
                  },
                  {
                    type: "value",
                    axisLabel: TEXT_STYLE,
                    axisLine: { lineStyle: { color: "#FFFFFF" } },
                    axisTick: { lineStyle: { color: "#FFFFFF" } },
                    splitLine: { lineStyle: { color: "#FFFFFF10" } },
                    position: "right",
                    splitNumber: 5,
                  },
                ],
                symbol: "none",
              };
              this.renderChart(
                this.missionAndPlanDataParse(chartOptions, datas, chartForm, true)
              );
            }
          } else if (res.code != 401) {
            // let msg = "请求数据失败";
            // if (!this.isEmptyStr(res.msg)) {
            //   msg = res.msg;
            // }
            // let tips = "<i class='el-icon-warn-tip'></i>" + msg;
            // this.$confirm(tips, "提示", {
            //   confirmButtonText: "好的",
            //   customClass: "customClass-style",
            //   iconClass: "",
            //   dangerouslyUseHTMLString: true,
            //   confirmButtonClass: "confirm-style",
            //   showCancelButton: false,
            // });
          }
        })
        .catch((error) => {});
    },
    renderChart(chartOptions) {
      let chart = this.$data["chart" + chartOptions.id];
      if (!chart) {
        var chartDom = document.getElementById(chartOptions.id);
        chart = this.$data["chart" + chartOptions.id] = echarts.init(chartDom);
      }
      var option = {
        title: {
          text: chartOptions.title,
          top: 5,
          left: 213,
          textStyle: {
            color: "#FFFFFF",
            fontSize: 18,
            fontFamily: "Alibaba PuHuiTi",
            fontWeight: 400,
          },
        },
        grid: { top: 35, right: 56, bottom: 72, left: 63 },
        tooltip: {
          trigger: "axis",
        },
        legend: {
          data: chartOptions.legendTitle,
          bottom: 18,
          textStyle: TEXT_STYLE,
          itemWidth: 8,
          itemHeight: 8,
        },
        color: chartOptions.chartColors,
        calculable: true,
        xAxis: [
          {
            type: "category",
            data: chartOptions.chartXAxis,
            axisLabel: TEXT_STYLE,
            axisLine: { lineStyle: { color: "#FFFFFF" } },
            axisTick: { lineStyle: { color: "#FFFFFF" } },
          },
        ],
        yAxis: [
          {
            type: "value",
            axisLabel: TEXT_STYLE,
            axisLine: { lineStyle: { color: "#FFFFFF" } },
            axisTick: { lineStyle: { color: "#FFFFFF" } },
            splitLine: { lineStyle: { color: "#FFFFFF10" } },
            splitNumber: 5,
          },
        ],
        series: [],
      };
      if (chartOptions.grid) {
        option.grid = chartOptions.grid;
      }
      if (chartOptions.legend) {
        option.legend = chartOptions.legend;
      }
      if (chartOptions.tooltipFormatter) {
        option.tooltip.formatter = chartOptions.tooltipFormatter;
      }
      //直接替换y轴
      if (chartOptions.yAxis) {
        option.yAxis = chartOptions.yAxis;
      }
      //直接替换数据
      if (chartOptions.series) {
        option.series = chartOptions.series;
      } else {
        const legendTitle = chartOptions.legendTitle;
        const datas = chartOptions.datas;
        const type = chartOptions.chartType;
        for (let index = 0; index < legendTitle.length; index++) {
          const data = datas[index];
          option.series.push({
            name: legendTitle[index],
            data,
            type,
          });
        }
      }
      //多坐标轴设置坐标轴
      if (chartOptions.yAxisIndexs) {
        const yAxisIndexs = chartOptions.yAxisIndexs;
        for (let index = 0; index < yAxisIndexs.length; index++) {
          option.series[index].yAxisIndex = yAxisIndexs[index];
        }
      }
      if (chartOptions.symbol) {
        const series = option.series;
        for (let index = 0; index < series.length; index++) {
          series[index].symbol = chartOptions.symbol;
        }
      }
      option && chart.setOption(option);
    },
    getChartParam() {
      const chartForm = this.$data.chartForm;
      return (
        "mark=" +
        chartForm.mark +
        "&startTime=" +
        chartForm.startTime +
        "&endTime=" +
        chartForm.endTime
      );
    },
    getQueryParam() {
      const tableForm = this.$data.tableForm;
      let params = "";
      if (!this.isEmptyStr(tableForm.flightName)) {
        params += "&flightName=" + tableForm.flightName;
      }
      if (!this.isEmptyStr(tableForm.uasSerialId)) {
        params += "&uasSerialId=" + tableForm.uasSerialId;
      }
      if (!this.isEmptyStr(tableForm.userName)) {
        params += "&userName=" + tableForm.userName;
      }
      return params;
    },
    getContinuityTimeArr(chartForm) {
      const type = chartForm.mark;
      const dateRange = chartForm.dateRange;
      const dateRangeArr = dateRange.split("~");
      const timeArr = [];
      if ("month" === type) {
        const startTimeArr = dateRangeArr[0].split("-");
        const endTimeArr = dateRangeArr[1].split("-");
        let startYear = parseInt(startTimeArr[0]);
        let startMonth = parseInt(startTimeArr[1]);
        let endYear = parseInt(endTimeArr[0]);
        let endMonth = parseInt(endTimeArr[1]);
        while (startYear < endYear || (startYear === endYear && startMonth <= endMonth)) {
          timeArr.push(
            startYear + "-" + (startMonth < 10 ? "0" + startMonth : "" + startMonth)
          );
          startMonth += 1;
          if (12 < startMonth) {
            startYear += 1;
            startMonth = 1;
          }
        }
      } else if ("quarter" === type) {
        const startTimeArr = dateRangeArr[0].split("-");
        const endTimeArr = dateRangeArr[1].split("-");
        let startYear = parseInt(startTimeArr[0]);
        let startQuarter = parseInt(startTimeArr[1]);
        let endYear = parseInt(endTimeArr[0]);
        let endQuarter = parseInt(endTimeArr[1]);
        while (
          startYear < endYear ||
          (startYear === endYear && startQuarter <= endQuarter)
        ) {
          timeArr.push(startYear + "-" + startQuarter);
          startQuarter += 1;
          if (4 < startQuarter) {
            startYear += 1;
            startQuarter = 1;
          }
        }
      } else if ("year" === type) {
        let startYear = parseInt(dateRangeArr[0]);
        const endYear = parseInt(dateRangeArr[1]);
        while (startYear <= endYear) {
          timeArr.push(startYear);
          startYear += 1;
        }
      }
      return timeArr;
    },
    missionAndPlanDataParse(chartOptions, datas, chartForm, special) {
      const trueDatas = {};
      for (let index = 0; index < datas.length; index++) {
        const element = datas[index];
        trueDatas[element.time] = {
          time: element.time,
          totalCount: element.totalCount,
          finish: element.finish,
          notFinish: element.notFinish,
          flightCount: element.flightCount,
          missionCount: element.missionCount,
          totalMileage: element.totalMileage,
          totalTime: element.totalTime,
          totalWeight: element.totalWeight,
        };
      }
      const timeArr = this.getContinuityTimeArr(chartForm);
      let company = "月";
      if ("quarter" === chartForm.mark) {
        company = "季度";
      } else if ("year" === chartForm.mark) {
        company = "年";
      }
      for (let index = 0; index < timeArr.length; index++) {
        const element = timeArr[index];
        if (trueDatas[element]) {
          const ele = trueDatas[element];
          chartOptions.chartXAxis.push(ele.time + company);
          if (special) {
            chartOptions.datas[0].push(ele.missionCount);
            chartOptions.datas[1].push(ele.flightCount);
            chartOptions.datas[2].push(ele.totalTime);
            chartOptions.datas[3].push(ele.totalWeight);
            chartOptions.datas[4].push(ele.totalMileage);
          } else {
            chartOptions.datas[0].push(ele.totalCount);
            chartOptions.datas[1].push(ele.finish);
            chartOptions.datas[2].push(ele.notFinish);
          }
        } else {
          chartOptions.chartXAxis.push(element + company);
          if (special) {
            chartOptions.datas[0].push(0);
            chartOptions.datas[1].push(0);
            chartOptions.datas[2].push(0);
            chartOptions.datas[3].push(0);
            chartOptions.datas[4].push(0);
          } else {
            chartOptions.datas[0].push(0);
            chartOptions.datas[1].push(0);
            chartOptions.datas[2].push(0);
          }
        }
      }
      return chartOptions;
    },
    query() {
      let vue = this;
      getRequest(
        "/uav-task-server/flight/getFlightSimpleListForDataStatistics.do?pagesize=" +
          this.$data.size +
          "&currentpage=" +
          this.$data.current +
          this.getQueryParam()
      )
        .then((res) => {
          res = res.data;
          if (null != res && 0 == res.code) {
            if (null != res.data && !this.isEmptyArray(res.data.list)) {
              this.$data.totalCount = res.data.total;
              this.$data.tableData = res.data.list;
            } else {
              this.$data.totalCount = 0;
              this.$data.tableData = [];
            }
          } else if (res.code != 401) {
            // let msg = "请求数据失败";
            // if (!this.isEmptyStr(res.msg)) {
            //   msg = res.msg;
            // }
            // let tips = "<i class='el-icon-warn-tip'></i>" + msg;
            // this.$confirm(tips, "提示", {
            //   confirmButtonText: "好的",
            //   customClass: "customClass-style",
            //   iconClass: "",
            //   dangerouslyUseHTMLString: true,
            //   confirmButtonClass: "confirm-style",
            //   showCancelButton: false,
            // });
          }
        })
        .catch((error) => {});
    }, //分页函数
    handleSizeChange: function (val) {
      this.size = val;
      this.query();
    },
    handleCurrentChange: function (current) {
      this.current = current;
      this.query();
    },
    callOnTabSelect() {
      this.$nextTick(function () {
        this.$refs.commonTable.doLayout();
      });
    }, //初始化时间选择范围
    initDateRange() {
      const chartForm = this.$data.chartForm;
      let type = chartForm.mark;
      const time = this.getTimeInfo();
      if ("month" === type) {
        if (!this.isEmptyStr(chartForm.monthDateRange)) {
          chartForm.dateRange = chartForm.monthDateRange;
        } else {
          const month = parseInt(time.month);
          let timeStart = "";
          if (month < 3) {
            timeStart = time.currentYear - 1 + "-" + (month === 1 ? 11 : 12);
          } else {
            timeStart =
              time.currentYear +
              "-" +
              (time.month - 2 < 10 ? "0" + (time.month - 2) : "" + (time.month - 2));
          }
          chartForm.dateRange = chartForm.monthDateRange =
            timeStart + "~" + time.currentYear + "-" + time.month;
        }
      } else if ("quarter" === type) {
        if (!this.isEmptyStr(chartForm.quarterDateRange)) {
          chartForm.dateRange = chartForm.quarterDateRange;
        } else {
          const quarter = parseInt(time.quarter);
          let timeStart = "";
          if (quarter < 3) {
            timeStart = time.currentYear - 1 + "-" + (quarter === 1 ? 3 : 4);
          } else {
            timeStart = time.currentYear + "-" + (quarter - 2);
          }
          chartForm.dateRange = chartForm.quarterDateRange =
            timeStart + "~" + time.currentYear + "-" + quarter;
        }
      } else if ("year" === type) {
        if (!this.isEmptyStr(chartForm.yearDateRange)) {
          chartForm.dateRange = chartForm.yearDateRange;
        } else {
          chartForm.dateRange = chartForm.yearDateRange =
            time.currentYear - 2 + "~" + time.currentYear;
        }
      }
      this.$refs.myDatePicker.resetPickerTime(type, chartForm.dateRange);
    },
    resetDateRange(timeData) {
      const chartForm = this.$data.chartForm;
      const type = this.$data.chartForm.mark;
      if ("month" === type) {
        chartForm.monthDateRange = timeData;
      } else if ("quarter" === type) {
        chartForm.quarterDateRange = timeData;
      } else if ("year" === type) {
        chartForm.yearDateRange = timeData;
      }
      chartForm.dateRange = timeData;
    },
    changeStatisticsTime() {
      this.initDateRange();
    },
    getTimeInfo() {
      const date = new Date();
      const month = date.getMonth() + 1;
      const quarter = "0" + Math.ceil(month / 3);
      return {
        currentYear: date.getFullYear(),
        month: month < 10 ? "0" + month : "" + month,
        quarter: quarter,
      };
    },
    resetRequestTime() {
      const chartForm = this.$data.chartForm;
      const dateRange = chartForm.dateRange;
      const type = chartForm.mark;
      const dateRangeArr = dateRange.split("~");
      if ("month" === type) {
        chartForm.startTime = dateRangeArr[0] + "-01";
        chartForm.endTime = dateRangeArr[1] + "-" + this.getMaxDay(dateRangeArr[1]);
      } else if ("quarter" === type) {
        const startQuarterArr = dateRangeArr[0].split("-");
        const startMonth = parseInt(startQuarterArr[1]) * 3 - 2;
        chartForm.startTime =
          startQuarterArr[0] +
          "-" +
          (startMonth < 10 ? "0" + startMonth : "" + startMonth) +
          "-01";

        const endQuarterArr = dateRangeArr[1].split("-");
        const endMonth = parseInt(endQuarterArr[1]) * 3;
        chartForm.endTime =
          endQuarterArr[0] + "-" + (endMonth < 10 ? "0" + endMonth : "" + endMonth);
        chartForm.endTime += "-" + this.getMaxDay(chartForm.endTime);
      } else if ("year" === type) {
        chartForm.startTime = dateRangeArr[0] + "-01-01";
        chartForm.endTime = dateRangeArr[1] + "-12-01";
      }
    }, //根据年和月获取当月最大的日期
    getMaxDay(time) {
      const timeArr = time.split("-");
      const date = new Date(parseInt(timeArr[0]), parseInt(timeArr[1]), 0).getDate();
      return date < 10 ? "0" + date : "" + date;
    },
  },
  watch: {},
  components: { MyDatePicker },
};
</script>

<style>
.mainDataStatisticsContainer {
  width: 100%;
  /* height: 100%; */
  height: calc(100% - 20px);
  overflow-x: auto;
}
.mainDataStatisticsContainer .dataStatisticsForms {
  min-width: 800px;
  height: 36px;
  margin-top: 23px;
}
.mainDataStatisticsContainer .dataStatisticsForms .el-form-item {
  float: left;
  margin-bottom: 0px !important;
}

.mainDataStatisticsContainer .el-form-item__label,
.mainDataStatisticsContainer .el-form-item__content,
.mainDataStatisticsContainer .el-select,
.mainDataStatisticsContainer .el-input,
.mainDataStatisticsContainer .el-form-item .el-input__inner,
.mainDataStatisticsContainer .el-input__suffix,
.mainDataStatisticsContainer .el-input__icon {
  height: 36px !important;
  line-height: 36px !important;
}
.mainDataStatisticsContainer .el-form-item__label {
  font-size: 16px;
  font-family: "AlibabaPuHuiTiL";
  font-weight: 300;
  color: #ffffff;
}
.mainDataStatisticsContainer .dataStatisticsForms .selectFormItem .el-input__inner {
  background: rgba(193, 193, 193, 0.1);
  border: 1px solid #c1c1c1;
  border-radius: 4px;
  color: #ffffff;
  width: 77px !important;
}
.mainDataStatisticsContainer .dataStatisticsForms .selectFormItem2 .el-input__inner {
  width: 120px !important;
}
.mainDataStatisticsContainer .chartMainContainer {
  min-width: 1520px;
  height: 300px;
  margin-top: 20px;
  position: relative;
  display: flex;
  justify-content: space-between;
}
.chartMainContainer .chartContainer {
  width: 32%;
  height: 298px;
  background: rgba(42, 46, 83, 0.5);
  border: 1px solid #0083fd;
  border-radius: 3px;
}

.mainDataStatisticsContainer .queryBtn {
  height: 36px;
  margin-top: 0px;
  font-family: AlibabaPuHuiTiM;
  font-weight: 400;
  color: #ffffff !important;
  border: none;
  background: #0083fd !important;
}
.mainDataStatisticsContainer div.mainTableContainer {
  margin-top: 16px !important;
}
.darkAdminHomeContainer
  .mainDataStatisticsContainer
  div.mainTableContainer
  .el-table
  .el-table__body-wrapper
  td {
  height: 60px !important;
}
</style>



// WEBPACK FOOTER //
// src/components/admin/statistics/dataStatistics.vue